export { latinMap } from './latin-map';
export { TypeaheadOptions } from './typeahead-options.class';
export { TypeaheadMatch } from './typeahead-match.class';

export {
  escapeRegexp,
  getValueFromObject,
  tokenize,
  latinize
} from './typeahead-utils';
export { TypeaheadContainerComponent } from './typeahead-container.component';
export { TypeaheadDirective } from './typeahead.directive';
export { TypeaheadModule } from './typeahead.module';



// WEBPACK FOOTER //
// ../../.tmp/typeahead/index.ts